module.exports = __webpack_public_path__ + "static/Rosewater0-444e323f010a4c8d5ef66c2c1f5ad2d7.png";